export const WORDSDICTR: {[key:string]:string } = {
       'empress': 'Empress of Mars is a Twelfth Doctor story.',
       'marinus': 'The Keys of Marinus is a first Doctor story.',
       'arbitan': 'Arbitan is the Keeper of the Conscience of Marinus.',
       'tlotoxl': 'Tlotoxl is the antagonist in The Aztecs.',
       'dortmun': 'Dortmun leads the resistence in The Dalek Invasion of Earth.',
       'roboman': 'The Robomen are controlled humans in The Dalek Invasion of Earth.',
       'slyther': 'The deadly Slyther is the Daleks\' pet in The Dalek Invasion of Earth.',
       'crusade': 'The Crusade is a first Doctor story.',
       'aridius': 'The Chase starts on the planet Aridius,',
       'meddler': 'The Time Meddler is a first Doctor story.',
       'drahvin': 'The Drahvins are the villains in Galaxy 4.',
       'mission': 'Mission to the Unknown is a first Doctor story that does not feature either Doctor nor companions.',
       'unknown': 'Mission to the Unknown is a first Doctor story that does not feature either Doctor nor companions.',
       'cutaway': 'Mission the the Unknown was also referred to as Dalek Cutaway.',
       'troilus': 'Vicki leaves Doctor Who to marry Troilus.',
       'refusis': 'In The Ark the human race journeys to the planet Refusis.',
       'clanton': 'In The Gunfighters, the Doctor, Steven and Dodo become caught up in the feud betwen the Clantons and Doc Holliday.',
       'savages': 'The Savages is a first Doctor story.',
       'snowcap': 'The Tenth Planet takes place at Snowcap Base.',
       'travers': 'Professor Travers appears in both The Abominable Snowmen and The Web of Fear.  His daughter Anne also appears in the latter.,',
       'seaweed': 'Sentient Seaweed in the form of foam is the monster in Fury from the Deep.',
       'mercury': 'The Doctor has, at least twice, had issues with the mercury fluid links in the Tardis.',
       'fiction': 'The Mind Robber takes place in the Land of Fiction.',
       'issigri': 'The Space Pirates revolves around the activities of the Issigri Mining Corporation.',
       'pirates': 'The Space Pirates is a Second Doctor Story.',
       'nestene': 'The Nestene Consciousness is the villain in Spearhead from Space.',
       'inferno': 'Inferno is a third Doctor story.',
       'primord': 'The Primords are monsters in Inferno.',
       'axonite': 'The Axons offer the Earth a wonder molecule called Axonite as a plot to absorb all the world\'s energy.',
       'daemons': 'The Daemons is a third Doctor story.',
       'peladon': 'The Curse of Peladon and the Monster of Peladon are both third Doctor stories.',
       'aggedor': 'Aggedor is the Sacred Royal beast of Peladon.',
       'mutants': 'The Mutants is a third Doctor story.',
       'marshal': 'The Marshal is the antagonist in The Mutants.',
       'galleia': 'Galleia is Queen of Atlantis in The Time Monster.',
       'doctors': 'The Three Doctors, The Five Doctors and the Two Doctors are all Doctor Who stories.',
       'bernice': 'The SS Bernice with its crew and passengers is stored in a miniscope in Carnvial of Monsters.  Bernice Summerfield is also a companion from the Virgin New Adventures with her own series of Big Finish stories.',
       'drashig': 'The Drashigs are monsters in Carnival of Monsters.',
       'warrior': 'The Time Warrior is a third Doctor story.',
       'rubeish': 'Professor Rubeish is a character in The Time Warrior.',
       'exxilon': 'Death to the Daleks takes place on the planet Exxilon.',
       'thalira': 'Queen Thalira is the ruler of Peladon in the Monster of Peldaon.',
       'monster': 'The Monster of Peladon is a third Doctor story.',
       'spiders': 'Planet of the Spiders is a third Doctor story.',
       'crystal': 'The Doctor takes a blue crystal from Metebelis 3 which he gives to Jo Grant as a wedding present.  When she returns it, it triggers the events of Planet of the Spiders.',
       'winters': 'Miss Winters is the villain in Robot.',
       'genesis': 'Genesis of the Daleks is a fourth Doctor story.',
       'revenge': 'Revenge of the Cybermen is a fourth Doctor story.',
       'scarman': 'The Scarman brothers feature prominently in Pyramids of Mars.',
       'android': 'The Android Invasion is a fourth Doctor story.',
       'morbius': 'The Brain of Morbius is a fourth Doctor story.',
       'krynoid': 'Krynoids are the monsters in The Seeds of Doom.',
       'kastria': 'In the Hand of Fear, Eldrad comes from Kastria.',
       'fendahl': 'Image of the Fendahl is a fourth Doctor story.',
       'ransome': 'Thea Ransome is possessed by the Fendahl in Image of the Fendahl.',
       'jethrik': 'Jethrik is a valuatel mineral that is the centre of Garron and Unstoffe\'s scam in The Ribos Operation.',
       'shrieve': 'The Shrieves are guards in The Ribos Operation.',
       'mentiad': 'The Mentiads are a group with psychic powers in The Pirate Planet.',
       'avatron': 'The Polyphase Avatron is the Captain\'s parrot in The Pirate Planet.',
       'rumford': 'Professor Rumford helps the Doctor and Romana in The Stones of Blood.',
       'cessair': 'Cessair of Diplos is the villain in The Stones of Blood.',
       'reynart': 'The Androids of Tara revolves around Prince Reynart\'s attempts to hold onto his throne.',
       'grendel': 'Count Grendel is the villain in The Androids of Tara.',
       'strella': 'Princess Strella is a character in The Androids of Tara and Romana\'s double.',
       'swampie': 'The Swampies are the indiginous inhabitants of Delta Magna in The Power of Kroll.',
       'adrasta': 'Lady Adrasta is the villain in Creature from the Pit.',
       'chloris': 'The planet Chloris appears in Creature from the Pit.',
       'vraxoin': 'Vraxoin is a highly addictive drug in Nightmare of Eden.',
       'mandrel': 'The Mandrels are the monster in Nightmare of Eden.',
       'skonnos': 'The Horns of Nimon takes place on Skonnos and Crinoth.',
       'crinoth': 'The Horns of Nimon takes place on Skonnos and Crinoth.',
       'soldeed': 'Soldeed is a villain in The Horns of Nimon.',
       'leisure': 'The Leisure Hive is a fourth Doctor story.',
       'destiny': 'Destiny of the Daleks is a fourth Doctor story.',
       'foamasi': 'The Foamasi are some of the villains in The Leisure Hive.',
       'argolis': 'Argolis is the location of the Leisure Hive.',
       'tachyon': 'Tachyons are manipulated in the Leisure Hive\'s Tachyon Recreation Generator.',
       'tigella': 'Tigella is a planet in Meglos.',
       'chronic': 'In Meglos the Doctor, Romana and K9 become trapped in a chronic hysteresis.',
       'decider': 'The Deciders govern the Starliner in Full Circle.',
       'camilla': 'Camilla is one of the three who rule in State of Decay.',
       'vanessa': 'Tegan\'s Aunt Vanessa is murdered by the Master in Logopolis.',
       'monarch': 'Monarch is the villain in Four to Doomsday.',
       'pudding': 'The Doctor accidentally starts the Great Fire of London in Pudding Lane in The Visitation.',
       'manussa': 'Snakedance takes place on Manussa.',
       'sumaran': 'The Mara destroyed the Sumaran Empire on Manussa.',
       'mawdryn': 'Mawdryn Undead is a fifth Doctor story.',
       'eternal': 'The Eternals are a race beings that live in the trackless wastes of eternity and are generally bored.',
       'sylvest': 'The Sylvest twins are the eponymous twins in The Twin Dilemma.',
       'dilemma': 'The Twin Dilemma is a sixth Doctor story.',
       'romulus': 'Romulus is one of the Twins in the Twin Dilemma.',
       'jaconda': 'The Twin Dilemma is set on Jaconda.',
       'dastari': 'Dastari is one of the antagonists in The Two Doctors.',
       'bandril': 'The Bandrils are an alien race in Timelash.',
       'kontron': 'A Kontron Tunnel ensares the Tardis in Timelash.',
       'drathro': 'Drathro is the villain in The Mysterious Planet.',
       'ravolox': 'Ravolox is the Mysterious Planet.',
       'sabalom': 'Sabalom Glitz is a con man in The Mysterious Planet, The Ultimate Foe and Dragonfire.',
       'crozier': 'Crozier replaces Peri\'s brain with that of Kiv in Mindwarp.',
       'vervoid': 'The Vervoids are the monster in Terror of the Vervoids.',
       'svartos': 'Dragonfire is set on Svartos.',
       'proamon': 'The villain Kane, in Dragonfire, wishes to return to his planet of Proamon.',
       'gilmore': 'Group Captain Gilmore is a character in Remembrance of the Daleks.',
       'killjoy': 'The Happiness Patrol hunts down Killjoys.',
       'prevail': 'Happiness will prevail.',
       'nemesis': 'Silver Nemesis is a Seventh Doctor Story.',
       'segonax': 'The Greatest Show in the Galaxy takes place on Segonax.',
       'psychic': 'The Psychic Circus is the Greatest Show in the Galaxy.',
       'bambera': 'Brigadier Winifred Bambera of UNIT appears in Battlefield.',
       'mordred': 'Mordred is a villain in Battlefield.',
       'gabriel': 'The events of Ghost Light take place at Gabriel Chase.',
       'unquiet': 'The Unquiet Dead is a Ninth Doctor story.',
       'gwyneth': 'Gwyneth helps the Doctor in the Unquiet Dead.  The actress goes on to place Gwen in Torchwood.',
       'dickens': 'Charles Dickens appears in The Unquiet Dead.',
       'trinity': 'The newsreader Trinity Wells appears in several Doctor Who stories.',
       'harriet': 'Harriet Jones first appears as an MP in Aliens of London/World War Three and returns as Prime Minister in The Christmas Invasion before dying in Journey\'s End.',
       'statten': 'Henry van Statten is the villain in Dalek.',
       'cardiff': 'Doctor Who is filmed in Cardiff and Torchwood was set there.',
       'station': 'Bad Wolf and The Parting of the Ways are set on the Game Station.',
       'parting': 'The Parting of the Ways is a Ninth Doctor episode.',
       'sycorax': 'The Sycorax are the monsters in The Christmas Invasion.',
       'reunion': 'School Reunion is a Tenth Doctor episode.',
       'lantern': 'The Idiot\'s Lantern is a Tenth Doctor epsiode.',
       'hartman': 'Yvonne Hartman leads Torchwood in Army of Ghosts and Doomsday.',
       'runaway': 'The Runaway Bride is a Tenth Doctor episode.',
       'racnoss': 'The Empress of the Racnoss is the villain in The Runaway Bride.',
       'lazarus': 'The Lazarus Experiment is a Tenth Doctor Story.',
       'redfern': 'Joan Redfern falls in love with the Doctor\'s human alter ego in Human Nature/The Famaily of Blood.',
       'latimer': 'Tim Latimer holds the Doctor\'s pocket watch in Human Nature/The Family of Blood.',
       'sparrow': 'Sally Sparrow is the protagonist in Blink.',
       'shipton': 'Billy Shipton is a character in Blink.',
       'weeping': 'The Weeping Angels are a monster in New Who.',
       'chantho': 'Chantho is Professor Yana\'s assistant in Utopia.',
       'valiant': 'The Valiant is the UNIT flying aircraft carrier, taken over by The Master in The Sound of Drums and Last of the Time Lords.',
       'paradox': 'The Master builds a Paradox Machine in The Sound of Drums.',
       'wilfred': 'Wilfred Mott is Donna\'s grandfather.',
       'titanic': 'Voyage of the Damned takes place on the starship Titanic.',
       'adipose': 'The Adipose are small fat creatures in Partners in Crime.',
       'pompeii': 'The Fires of Pompeii is a Tenth Doctor story.',
       'unicorn': 'The Unicorn and the Wasp is a Tenth Doctor story.',
       'silence': 'Silence in the Library is a Tenth Doctor story.',
       'library': 'Silence in the Library is a Tenth Doctor story.',
       'magambo': 'Unit Captain Magambo appears in Turn Left and Planet of the Dead.',
       'cascade': 'The Earth is taken to the Medusa Cascade in The Stolen Earth.',
       'journey': 'Journey\'s End is a Tenth Doctor story and Journey to the Centre of the Tardis is an Eleventh Doctor story.',
       'victory': 'Victory of the Daleks is an Eleventh Doctor story.',
       'vincent': 'Vincent and the Doctor is an Eleventh Doctor story.',
       'sardick': 'Kazran Sardick is the antagonist in A Christmas Carol.',
       'everett': 'Canton Everett Delarware III helps the Doctor in The Impossible Planet/Day of the Moon.',
       'terrors': 'Night Terrors is an Eleventh Doctor story.',
       'handbot': 'The Handbots appear in The Girl Who Waited.',
       'complex': 'The God Complex is an Eleventh Doctor episode.',
       'closing': 'Closing Time is an Eleventh Doctor episode.',
       'wedding': 'The Wedding of River Song is an Eleventh Doctor episode.',
       'winston': 'Winston Churchill appears in several Eleventh Doctor stories.',
       'riddell': 'Riddell is a big game hunter in Dinosaurs on a Spaceship.',
       'solomon': 'Solomon is the villain in Dinosaurs on a Spaceship.',
       'snowmen': 'The Abominable Snowmen and The Snowmen are both Doctor Who stories.',
       'akhaten': 'The Rings of Akhaten is an eleventh Doctor story.',
       'skaldak': 'Skaldak is the Ice Warrior enemy in Cold War.',
       'crimson': 'The Crimson Horror is an Eleventh Doctor story.',
       'whisper': 'The Whisper Men are the monsters in The Name of the Doctor.',
       'arcadia': 'Arcadia is a city on Gallifrey that fell during the Time War.',
       'curator': 'Tom Baker appears as The Curator in Day of the Doctor.',
       'handles': 'Handles is the Doctor\'s Cyberhead.',
       'blitzer': 'The Skovox Blitzer appears in The Caretaker.',
       'express': 'Mummy on the Orient Express is a Twelfth Doctor story.',
       'stewart': 'Kate Stewart is the daughter of the Brigadier.',
       'prentis': 'Prentis is a Tivolian undertaker in Under the Lake/Before the Flood.',
       'ashildr': 'Ashildr first appears in The Girl Who Died and becomes an antagonist in Season 9.',
       'leandro': 'Leandro is the villain in The Woman who Lived.',
       'halassi': 'The Halassi Androvar is the most valuable diamond in the universer and is inside the brain of King Hydroflax.',
       'heather': 'Heather is Bill\'s girlfriend - and also a sentient puddle.',
       'veritas': 'Veritas is a text that causes readers to commit suicide in Extremis.',
       'pyramid': 'The Pyramid at the End of the World is a Twelfth Doctor story.',
       'tzimsha': 'Tzim-Sha is the villain in The Woman who Fell to Earth and The Battle of Ranskor av Kolos.',
       'umbreen': 'Yaz\'s nani is called Umbreen.',
       'kerblam': 'Kerblam! is a Thirteenth Doctor story.',
       'ribbons': 'Ribbons is a character in It Takes You Away.',
       'spyfall': 'Spyfall is a Thirteenth Doctor story.',
       'skithra': 'The Skithra are the monsters in Nikola Tesla\'s Night of Terror.',
       'praxeus': 'Praxeus is a Thirteenth Doctor story.',
       'diodati': 'The Haunting of Villa Diodati is a thirteenth Doctor story.',
       'shelley': 'Percy Bysshe Shelley appears in the Haunting of Villa Diodati.',
       'sharmus': 'Ko Sharmus helps humans through the boundary in Ascension of the Cybermen and sacrifices himself to save the universe in The Timeless Children.',
       'brendan': 'Brendan is a dream version of the Doctor in Ascension of the Cybermen.',
       'tecteun': 'Tecteun is the Doctor\'s adoptive mother.',
       'seacole': 'Mary Seacole appears in War of the Sontarans.',
       'atropos': 'The Temple of Atropos contains the Mouri on the planet time.',
       'village': 'Village of the Angels is a Thirteenth Doctor story.',
       'jericho': 'Professor Jericho assists Yaz and Dan in Flux.',
       'shirley': 'Shirley Bingham is UNIT\'s scientific advisor in The Star Beast and The Giggle.',
       'bingham': 'Shirley Bingham is UNIT\'s scientific advisor in The Star Beast and The Giggle.',
       'ibrahim': 'Colonel Ibrahim is a UNIT colonel who appears in The Giggle, The Legend of Ruby Sunday/The Empire of Death and Wish World/The Reality War.',
       'maestro': 'Maestro is the villain in The Devil\'s Chord.',
       'beatles': 'The Beatles appear in The Devil\'s Chord.',
       'mantrap': 'The Man-Traps are the monsters in Dot and Bubble.',
       'chuldur': 'The Chuldur are the monters in Rogue.',
       'gibbons': 'Morris Gibbons is the UNIT scientific advisor in The Legend of Ruby Sunday and Empire of Death.',
       'william': 'William Hartnell played the first Doctor.',
       'foreman': 'I. M. Foreman owned Totter\'s Yard from and Susan borrowed the surname.',
       'barbara': 'Barbara Wright was a companion to the first Doctor.',
       'russell': 'Russell T. Davies bought back Doctor Who in 2003.',
       'maureen': 'Maureen O\'Brien played companion Vicki.',
       'chaplet': 'Dodo Chaplet was a companion to the first Doctor.',
       'jackson': 'Ben Jackson was a companion to the first and second Doctors.',
       'michael': 'Michael Craze played companion Ben Jackson.',
       'kingdom': 'Sara Kingdom was a companion to the first Doctor.',
       'patrick': 'Patrick Troughton played the second Doctor.',
       'padbury': 'Wendy Padbury played companion Zoe Heriot.',
       'watling': 'Deborah Watling played companion Victoria Waterfield.',
       'deborah': 'Deborah Watling played companion Victoria Waterfield.',
       'manning': 'Katy Manning played companion Jo  Grant.',
       'jameson': 'Louise Jameson played companion Leela.',
       'matthew': 'Matthew Waterhouse played companion Adric.',
       'jovanka': 'Tegan Jovanka was a companion to the fourth and fifth Doctors.',
       'pertwee': 'Jon Pertwee played the third Doctor.',
       'davison': 'Peter Davison played the fifth Doctor.',
       'melanie': 'Melanie Bush was a companion to the sixth and seventh Doctors.',
       'tennant': 'David Tennant played the tenth and fourteenth Doctors.',
       'agyeman': 'Freema Agyeman played companion Martha Jones.',
       'darvill': 'Arthur Darvill played companion Rory Williams.',
       'coleman': 'Jenna Louise Coleman played companion Clara Oswald.',
       'capaldi': 'Peter Capaldi played the twelfth Doctor.',
       'bradley': 'Bradley Walsh played companion Graham O\'Brien.',
       'lambert': 'Verity Lambert was the first producer of Doctor Who.',
       'derrick': 'Derrick Sherwin was a producer of Doctor Who.',
       'sherwin': 'Derrick Sherwin was a producer of Doctor Who.',
       'gardner': 'Julie Gardner is an executive producer of Doctor Who.',
       'skinner': 'Caroline Skinner was an executive producer of Doctor Who.',
       'penhale': 'Faith Penhale was an executive producer of Doctor Who.',
       'minchin': 'Brian Minchin was an executive producer of Doctor Who.',
       'tranter': 'Jane Tranter is an executive producer of Doctor Who.',
       'collins': 'Joel Collins is an executive producer of Doctor Who.',
       'spooner': 'Dennis Spooner was a script editor on Doctor Who.',
       'douglas': 'Douglas Adams was a script editor on Doctor Who.',
       'bidmead': 'Christopher H. Bidmead was a script editor on Doctor Who.',
       'anthony': 'Anthony Ainley played the Master in the 1980s.',
       'cartmel': 'Andrew Cartmel was a scrip editor on Doctor Who.',
       'grainer': 'Ron Grainer composed the Doctor Who theme tune.',
       'akinola': 'Segun Akinola composed the music for Doctor Who during the thirteenth Doctor years.',
       'delgado': 'Roger Delgado played the first Master.',
       'beevers': 'Geoffrey Beevers played the Master in The Keeper of Traken.',
       'roberts': 'Eric Roberts played the Master in the TV Movie.',
       'corsair': 'The Corsair is a Time Lord mentioned in The Doctor\'s Wife.',
       'krontep': 'King Yrcanos, who marries Peri, comes from the planet Krontep.',
       'urbanka': 'The aliens in Four to Doomsday come from Urbanka.',
       'usurius': 'The villain in The Sunmakers comes from Usurius.',
       'vulpana': 'Mags in The Greatest Show in the Galaxy comes from Vulpana.',
       'aridian': 'The Aridians live on Aridius in The Chase.',
       'primoid': 'People turn into Primoids in Inferno.',
       'usurian': 'The Collector in The Sunmakers is a Usurian.',
       'vampire': 'The Time Lords fought the great Vampires long ago in their history.',
       'cleaner': 'In Paradise Towers people get taken by the Cleaners.',
       'cheetah': 'The Cheetah People appear in Survival.',
       'illyria': 'Illyria Seven is where Solomon purchased his robots in Dinosaurs on a Spaceship.',
       'remnant': 'The Remnants appear in The Ghost Monument.',
       'beltane': 'The Daemons takes place at Beltane.',
       'capitol': 'The City on Gallifrey at the centre of Time Lord society is referred to as the Capitol.',
       'captain': 'The Captain is one of the villains in The Pirate Planet.',
       'charged': 'Travel between E-Space and N-Space is possible through Charged Vaccuum Emboitments.',
       'demeter': 'The Vervoids grow from Demeter Seeds.',
       'hostile': 'The Hostile Action Displacement System (HADS) very occasionally removes the Tardis from danger.',
       'yrcanos': 'King Yrcanos maries Peri.',
       'almondo': 'Joy Almondo is a pseudo-companion in Joy to the World.',
       'belinda': 'Belinda Chandra is a companion of the Fifteenth Doctor.',
       'chandra': 'Belinda Chandra is a companion of the Fifteenth Doctor.',
       'contest': 'The Interstellar Song Contest is a Fifteenth Doctor episode.',
       'hellion': 'The Hellions are a horned species that appear in The Interstellar Song Contest.',
       'reality': 'The Reality War is a Fifteenth Doctor story.',
};



